import { longTextTruncate } from 'utils/helper'

export const GridColumnSimple = (value: string | undefined, totalChar: number) => {
  if (!value) {
    return '---'
  }

  const convertedValue = longTextTruncate(value, totalChar)
  return convertedValue ? convertedValue : '---'
}
